<script setup lang="ts">
import LeChevronRight from "@dsk/icons/LeChevronRight.vue";
import { PopoverButton } from "@headlessui/vue";

interface Props {
  isActive?: boolean;
  badge?: number | null;
}

const props = withDefaults(defineProps<Props>(), {
  isActive: false,
  badge: null
});
</script>

<template>
  <PopoverButton as="template">
    <button
      type="button"
      class="le-dictionaries-selector-button"
      :class="{ 'le-dictionaries-selector-button--active': props.isActive }"
    >
      <span class="le-dictionaries-selector-button__content">
        <span aria-hidden="true" class="le-dictionaries-selector-button__badge">
          <template v-if="props.badge !== null">{{ props.badge }}</template>
        </span>
        <span class="le-dictionaries-selector-button__text">
          <slot />
        </span>
        <LeChevronRight class="le-dictionaries-selector-button__icon" role="presentation" />
      </span>
    </button>
  </PopoverButton>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
@import "@/assets/styles/z-index.less";

.le-dictionaries-selector-button {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 16px 18px;
  transition: all 75ms ease-out;
  border: 0;
  border-radius: 4px;
  background-color: @colors[@neutrals][100];
  box-shadow: @shadows[dropdown];
  color: @colors[@neutrals][300];
  font-family: @font-family-body;
  font-size: 14px;
  font-weight: 600;
  text-align: left;

  &:hover {
    background-color: @colors[@secondary][200];
  }

  &.focus-visible {
    .focus-outline(green);
  }

  &--active {
    z-index: @le-dictionary-selector-button__active-z-index;
    color: @colors[@neutrals][500];
  }

  &__content {
    display: flex;
    align-items: center;
  }

  &__text {
    width: 75%;
    .text-fade();
  }

  &__badge {
    display: grid;
    min-width: 26px;
    height: 26px;
    margin-right: 14px;
    overflow: hidden;
    border-radius: 50%;
    background-color: @colors[@primary][500];
    color: white;
    font-size: 14px;
    font-weight: 700;
    place-items: center;
  }

  &__icon {
    margin-left: auto;
    color: @colors[@secondary][800];
  }

  &--active &__icon,
  &:hover &__icon {
    color: @colors[@primary][500];
  }
}
</style>
